
    <div class="pricing-column">
            <div class="pc-header border">
                <h4>{{title}}</h4>
            </div>
            <div class="pc-detail border" *ngIf="!this.isCustomPlan">
                <div class="pc-per-user">
                    <span class="pr-symbol">$</span><span class="pr-amount">{{this.priceString[0]}}</span><span class="pr-am-deci">.{{this.priceString[1]}}</span><span class="pr-txt">/user/month</span>
                </div>
                <div class="min-user-txt">{{subtitle}}</div>
            </div>
            <div class="pc-selection border"  *ngIf="!this.isCustomPlan">
                <itb-default-button [text]="this.buttonText" [className]="'primary'" [iconClassName]="'tick'"></itb-default-button>
            </div>  
            <div class="pc-feature" [ngClass]="{'small':this.isCustomPlan }">
                <ul>
                    <li *ngFor="let feature of featuresList">
                        <itb-icon [className]="'tick'" ></itb-icon> {{feature}}
                    </li>
                </ul>
            </div>
        </div>

        
